import React from 'react';
import { Link } from 'react-router-dom';
import { organizationSchema } from '../lib/schema';
import { PageMeta, PageHero, SectionHead, CtaBand, Icon } from '../components/ui';

const VALUES = [
  { icon: 'tag', title: 'Clear prices', text: 'Package prices and inclusions are published up front, and the final price is confirmed before any work starts.' },
  { icon: 'clock', title: 'Your time matters', text: 'We come to where your car is parked so you do not lose time driving to a car wash or waiting in a queue.' },
  { icon: 'chat', title: 'Easy to reach', text: 'Bookings, changes and questions are handled directly with our team on WhatsApp or by phone.' },
  { icon: 'sparkle', title: 'Care for your car', text: 'Each package has a defined checklist, so you know exactly what will be done.' }
];

const About = () => (
  <>
    <PageMeta
      title="About Quick Way | Mobile Car Wash Company in Abu Dhabi & Dubai"
      description="Quick Way is a mobile car wash and detailing service for homes, buildings and offices in Abu Dhabi and Dubai, bookable on WhatsApp or the Android app."
      path="/about"
      crumbs={[{ name: 'About', path: '/about' }]}
      jsonLd={[organizationSchema()]}
    />
    <PageHero eyebrow="About us" title="About Quick Way">
      <p>Quick Way is a mobile car wash and detailing service for drivers in Abu Dhabi and Dubai. We bring the car wash to your home, building car park or office.</p>
    </PageHero>

    <section className="section">
      <div className="container container--narrow prose">
        <h2>Why we started Quick Way</h2>
        <p>
          Keeping a car clean in the UAE is a weekly job. Dust and sand settle fast, and driving to a car wash station
          then waiting in a queue takes time most people would rather spend elsewhere. Quick Way removes that trip:
          you choose a package, tell us where the car is, and our team comes to you.
        </p>
        <h2>What we do</h2>
        <p>
          We offer three packages, from an AED 30 exterior wash to an AED 65 detail with clay bar, wax and leather care,
          plus extras such as odour removal and ceramic coating. Drivers who want a regularly clean car can choose a
          monthly plan, and businesses can arrange scheduled washes for their fleet.
        </p>
        <p>
          You can order in the Quick Way app for Android, through our <Link to="/book">booking form</Link>, or on WhatsApp.
          We currently serve <Link to="/mobile-car-wash-abu-dhabi">Abu Dhabi</Link> and <Link to="/mobile-car-wash-dubai">Dubai</Link>.
        </p>
      </div>
    </section>

    <section className="section section--tint">
      <div className="container">
        <SectionHead title="How we work" />
        <div className="grid grid-4">
          {VALUES.map((v) => (
            <div key={v.title} className="feature">
              <span className="icon-tile"><Icon name={v.icon} /></span>
              <h3>{v.title}</h3>
              <p>{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="section">
      <div className="container container--narrow center">
        <h2 className="h-section">Work with us</h2>
        <p>Car wash professionals and companies can apply to join Quick Way. Businesses can request a fleet quote.</p>
        <div className="btn-row btn-row--center">
          <Link to="/partner" className="btn btn-outline-dark">Become a partner</Link>
          <Link to="/corporate-fleet-car-wash" className="btn btn-outline-dark">Fleet services</Link>
        </div>
      </div>
    </section>

    <CtaBand source="about" />
  </>
);

export default About;
